// JavaScript Document
// Simple Validation for use with jQuery 1.8+

$(document).ready(function() {
  $("form").submit(function() {
    var formId = $(this).attr('id');
    $("#" + formId + " .required").each(function() {
      //if radio or checkbox
      if ($(this).attr('type') == 'radio' || $(this).attr('type') == 'checkbox') {
        var name = $(this).attr('name');
        if ($('input[name="' + name + '"]:checked').length > 0) {
          $('input[name="' + name + '"]').removeClass("missing");
          $('input[name="' + name + '"]').parent().removeClass("missingField");
        } else {
          if (!$(this).hasClass("missing")) {
            $(this).addClass("missing");
            $('input[name="' + name + '"]').parent().addClass("missingField");
          }
        }
      } else {
        if ($(this).val() == "") {
          if (!$(this).hasClass("missing"))
            $(this).addClass("missing");
          }
        else {
          if ($(this).hasClass("validateEmail") && !validateEmail($(this).val())) {
            $(this).addClass("missing");
          } else {
            $(this).removeClass("missing");
          }
        }
      }
      if ($(this).hasClass('datepicker')) {
        if ($(this).val() == '0000-00-00') {
          $(this).addClass("missing");
        }
      }
    });

    //remove required for all other classes
    $("form").each(function() {
      if ($(this).attr('id') != formId) {
        $("#" + $(this).attr('id') + " .required").each(function() {
          $(this).removeClass("missing");
        });
      }
    });

    if ($(".missing").length > 0) {
      if ($("#formErrors").length == 0){
        $('<p class="msg error" id="formErrors">Le ou les champs surlignés ci-dessous sont obligatoires.</p>').insertBefore("#" + formId);
      } else {
        $("#formErrors").html("Le ou les champs surlignés ci-dessous sont obligatoires.");
      }
      $("#formErrors").fadeIn(function() {
        $('html, body').animate({
          scrollTop: $(".missing").first().offset().top - 150,
        });
      });
    }
    return $(".missing").length > 0
      ? false
      : true;
  });

  $(document).on("keyup", "input.missing", function() {
    if ($(this).val() != "") {
      $(this).removeClass("missing");
      if ($(".missing").length == 0)
        $("p#formErrors").fadeOut();
      }
    });
  $(document).on("change", "select.missing", function() {
    if ($(this).val() != "") {
      $(this).removeClass("missing");
      if ($(".missing").length == 0)
        $("p#formErrors").fadeOut();
      }
    });
  $(document).on("click", "input[type=radio]", function() {
    var name = $(this).attr('name');
    if ($(this).is(":checked")) {
      $('input[name="' + name + '"]').removeClass("missing");
      $('input[name="' + name + '"]').parent().removeClass("missingField");
    }
  });
  $(document).on("click", "input[type=checkbox]", function() {
    var name = $(this).attr('name');
    if ($(this).is(":checked")) {
      $('input[name="' + name + '"]').removeClass("missing");
      $('input[name="' + name + '"]').parent().removeClass("missingField");
    }
  });

});

function validateEmail(elementValue) {
  var emailPattern = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
  return emailPattern.test(elementValue);
}
